import script from "./apply-technical-support.vue?vue&type=script&lang=ts&setup=true"
export * from "./apply-technical-support.vue?vue&type=script&lang=ts&setup=true"

import "./apply-technical-support.vue?vue&type=style&index=0&id=9236177a&lang=scss"

const __exports__ = script;

export default __exports__